/**
 * 财务审核列表页面
 * 2020-11-26 chenxiaojian
 */
import React from 'react';

import PageList from '../ui/PageList';

import server from "../../../axios/server";
import menuData from '../../../route/menu_wxgzh';

const financialAuditStatus = { 0: "待审核", 1: "审核通过", 2: "审核不通过" };


class FinancialList extends React.Component {


    itemClick = (id, e) => {
        let href = server.webServerUrl + menuData["WXGZH_FINANCIAL_DETAIL"].url + "?id=" + id;
        window.location.href = href;
    }

    renderRow = (rowData, sectionID, rowID, highlightRow) => {
        return (<div style={{ height: '52px', width: '100%', padding: '5px' }} onClick={this.itemClick.bind(this, rowData.id)}>
            <div style={{ float: 'left', width: '50%', height: '100%' }}>
                <div>{rowData.type}</div>
                <div>{rowData.insertTime}</div>
            </div>
            <div style={{ float: 'left', width: '30%' }}>
                <span style={{ lineHeight: '42px', fontSize: '20px', color: '#cc1616' }}>
                    {rowData.amount}
                </span>
            </div>
            <div style={{ float: 'left', width: '20%' }}>
                <span style={{ lineHeight: '42px', color: '#1680cc' }}>
                    {financialAuditStatus[rowData.status]}
                </span>
            </div>
        </div>);
    }

    render() {
        return (
            <PageList
                url="/financial/audit/query/page"
                renderRow={this.renderRow}
                requestType="get"
                loadData={(func) => { this.loadData = func; }}
            />
        );
    }
}

export default FinancialList;